import { useDispatch } from "react-redux";

import { setLayoutDashboardTitle } from "../../store/ui-slice";
import { useEffect } from "react";
import PermintaanMinyakMain from "../../features/permintaan-minyak/components/permintaan-minyak-main";

const title = "Permintaan Minyak";

const PermintaanMinyakPage = () => {
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(setLayoutDashboardTitle({ title }));
  }, []);

  return <PermintaanMinyakMain />;
};
export default PermintaanMinyakPage;
